module.exports = __webpack_public_path__ + "img/1.1b8f6c01.png";